import { render, staticRenderFns } from "./SendOrder.vue?vue&type=template&id=45101b9c&scoped=true"
import script from "./SendOrder.vue?vue&type=script&lang=js"
export * from "./SendOrder.vue?vue&type=script&lang=js"
import style0 from "./SendOrder.vue?vue&type=style&index=0&id=45101b9c&prod&lang=scss"
import style1 from "./SendOrder.vue?vue&type=style&index=1&id=45101b9c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45101b9c",
  null
  
)

export default component.exports